import React from "react"

import {
    GridCell,
    Icon,
    Message,
    Theme,
} from "@bdfx/mergado-ui-kit"

import trans from "trans"

import { DYNAMIC_TEXT_TYPE, IMAGE_FROM_ELEMENTS_TYPE, RATING_TYPE, TEXT_INSIDE_SHAPE_TYPE } from "shape-entities/types/shape";
import MergadoElementSelect from "app/components/mergado-element-select";
import { getElementValue } from "./helpers";


const XmlElementSelectForm = ({ fieldName, formName, shape, activeShapeId, project, randomProduct, change, updateShapeSizeDebounced }) => {
    const elementValue = shape[fieldName]   //rating_xml_element|rating_count_xml_element|text_xml_element|image_xml_element
    let isMatch = true

    if (elementValue && project.mergado_element_regex) {
        const regex = new RegExp(project.mergado_element_regex)
        isMatch = regex.test(elementValue)
    }

    return (
        <React.Fragment>
            <GridCell title={trans("xml_element_name")}>
                <MergadoElementSelect
                    value={elementValue}
                    handleChange={(newValue: string) => {
                        change(formName, `shapes.${activeShapeId}.${fieldName}`, newValue)

                        if (randomProduct && randomProduct.serialized_data && typeof newValue === "string") {
                            const text = getElementValue(randomProduct.serialized_data, newValue)
                            if (typeof text === "string") {
                                updateShapeSizeDebounced(`shapes.${activeShapeId}`, activeShapeId, false)
                            }
                        } else {
                            change(formName, `shapes.${activeShapeId}.text_content`, '')
                            change(formName, `shapes.${activeShapeId}.text_content_replaced`, '')
                            console.debug('no random product or empty', randomProduct)
                        }

                        if (fieldName === 'rating_xml_element' && newValue) {
                            if (newValue.startsWith('BFE_')) {
                                change(formName, `shapes.${activeShapeId}.rating_max_value`, 100)
                            } else {
                                change(formName, `shapes.${activeShapeId}.rating_max_value`, 5)
                            }
                        }
                    }}
                    //not any more for text inside shape!
                    error={shape.type === TEXT_INSIDE_SHAPE_TYPE && shape.points && Array.isArray(shape.points) && shape.points.length > 0 && !elementValue ? trans('element_not_selected') : (!isMatch ? trans('no_match_with_element_regexp') : undefined)}
                    invalid={([TEXT_INSIDE_SHAPE_TYPE, IMAGE_FROM_ELEMENTS_TYPE, DYNAMIC_TEXT_TYPE, RATING_TYPE].includes(shape.type) && !elementValue) || !isMatch}
                />

                {!isMatch &&
                    <Message
                        type={'error'}
                        icon={<Icon type={'exclamation-triangle'} color={Theme.red} size={28} />}
                        text={trans('no_match_with_element_regexp') + ': ' + project.mergado_element_regex}
                    />
                }
            </GridCell>
        </React.Fragment>
    )
}

export default XmlElementSelectForm